// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__+f0eC","headerWrapper":"style_headerWrapper__g2dpr","title":"style_title__0CQrM","img":"style_img__1tbIf"};